"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scriptBold = void 0;
exports.scriptBold = {};
//# sourceMappingURL=script-bold.js.map